// @react/hooks/useCalendarCalendarPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarCalendarPolicyStore } from '@core/stores';

/**
 * React hook for CalendarPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendarCalendarPolicy } from '@react/hooks';
 *
 * const CalendarPolicyList = observer(() => {
 *   const store = useCalendarCalendarPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendarCalendarPolicy() {
  return calendarCalendarPolicyStore;
}
